var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkCloseBlack = function SvgCkCloseBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 10.586L16.9497 5.63599L18.3637 7.04999L13.4137 12L18.3637 16.95L16.9497 18.364L11.9997 13.414L7.04974 18.364L5.63574 16.95L10.5857 12L5.63574 7.04999L7.04974 5.63599L11.9997 10.586Z",
    fill: "#05141F"
  })));
};
export { SvgCkCloseBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk5OTcgMTAuNTg2TDE2Ljk0OTcgNS42MzU5OUwxOC4zNjM3IDcuMDQ5OTlMMTMuNDEzNyAxMkwxOC4zNjM3IDE2Ljk1TDE2Ljk0OTcgMTguMzY0TDExLjk5OTcgMTMuNDE0TDcuMDQ5NzQgMTguMzY0TDUuNjM1NzQgMTYuOTVMMTAuNTg1NyAxMkw1LjYzNTc0IDcuMDQ5OTlMNy4wNDk3NCA1LjYzNTk5TDExLjk5OTcgMTAuNTg2WiIgZmlsbD0iIzA1MTQxRiIvPgo8L3N2Zz4K";